import { render } from "./MemberElipsisMenu.vue?vue&type=template&id=8f9a66d4"
import script from "./MemberElipsisMenu.vue?vue&type=script&lang=js"
export * from "./MemberElipsisMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__